module.exports = __webpack_public_path__ + "static/media/Spreadsheet.b3171d93.svg";